import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

const BookmarkletInfo = () => {
    const [copied, setCopied] = useState(false);

    // This script will:
    // 1. Prompt user for tags (optional, simplified for now)
    // 2. Redirect to app/bookmarks with params
    // Note: Since we can't easily make a POST request from a bookmarklet without CORS issues to a local server from HTTPS sites,
    // we will redirect the user to our app's "Add" page with the URL pre-filled.
    
    // We use a fixed IP/host in the bookmarklet because window.location isn't available when the bookmarklet runs on another site
    // Ideally this would be configurable or use a public redirector, but for local use we default to localhost:5183
    // Users accessing via network IP would need to manually update this if they want to add bookmarks from other devices
    const bookmarkletCode = `javascript:(function(){var url=encodeURIComponent(window.location.href);var title=encodeURIComponent(document.title);window.open('http://localhost:5183/bookmarks?add=true&url='+url+'&title='+title,'_blank');})();`;

    const handleCopy = () => {
        navigator.clipboard.writeText(bookmarkletCode);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-xl p-6 mb-8">
            <h3 className="text-lg font-bold text-blue-800 dark:text-blue-300 mb-2">
                如何添加 "收藏至 YOOTags" 到浏览器？
            </h3>
            <p className="text-sm text-slate-600 dark:text-slate-400 mb-4">
                只需将下方的按钮拖拽到浏览器的 <strong>书签栏</strong> 即可。
                <br />
                在任意网页点击该书签，即可一键收藏到 YOOTags！
            </p>
            
            <div className="flex flex-col sm:flex-row items-center gap-4 bg-white dark:bg-slate-800 p-4 rounded-lg border border-slate-200 dark:border-slate-700">
                <a 
                    href={bookmarkletCode}
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg shadow-md cursor-grab active:cursor-grabbing flex items-center gap-2"
                    title="拖拽我到书签栏"
                    onClick={(e) => e.preventDefault()} // Prevent clicking
                >
                    📑 收藏至 YOOTags
                </a>
                <span className="text-xs text-slate-400">← 拖拽这个按钮到书签栏</span>

                <div className="ml-auto flex items-center gap-2">
                    <span className="text-xs text-slate-400">或者复制脚本代码：</span>
                    <button 
                        onClick={handleCopy}
                        className="p-2 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg text-slate-500 transition-colors"
                        title="复制代码"
                    >
                        {copied ? <Check size={16} className="text-green-500" /> : <Copy size={16} />}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BookmarkletInfo;
